import {
    Badge,
    Box,
    Button,
    FileInput,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { useEffect, useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchableSelect } from '../../../../common';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { hasRole } from '../../../../../utils/roles';
import useAddMessageGroup from '../../../../../http/mutations/groups/useAddMessageGroup';
import { useAuthStore } from '../../../../../store';
import { useForm } from '@mantine/form';

const CreateUserRouteModal = ({ routeId, existing, opened, close }) => {
    const userProfile = useAuthStore((state) => state.userProfile);
    const form = useForm({
        initialValues: {
            routeId: routeId,
            userId: hasRole(userProfile, 'SUPER_ADMIN')
                ? userProfile?.id.toString()
                : null,
        },

        validate: {
            /*emailOrUsername: isNotEmpty('Username or email is required'),
                password: (val) =>
                    val.length <= 6
                        ? 'Password should include at least 6 characters'
                        : null,*/
        },
    });

    useEffect(() => {
        form.reset();
    }, [opened]);

    const { isPending, mutate: addOrUpdate } = useAddMessageGroup();

    const onSubmit = (model) => {
        addOrUpdate(model, {
            onSuccess(data, variables, context) {
                close();
            },
            onError(error, variables, context) {
                // setError(error);
            },
        });
    };

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size={'md'}>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>Create User Route</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack gap={'xs'}>
                            <Group justify='flex-end'>
                                <Button
                                    type={'submit'}
                                    disabled={isPending || !form.isValid()}
                                    rightSection={
                                        isPending ? (
                                            <FontAwesomeIcon
                                                icon={faSpinnerThird}
                                                spin
                                            />
                                        ) : null
                                    }>
                                    Create
                                </Button>
                            </Group>
                        </Stack>
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default CreateUserRouteModal;
